import { Avatar, AvatarImage, AvatarFallback } from "../../../components/ui/Avatar"
import { Button } from "../../../components/ui/button"
import { Card, CardContent } from "../../../components/ui/card"
import { ConnectionWithProfile } from "../../../services/UserService"
import { useState } from "react"
import { Loader2 } from "lucide-react"
interface ConnectionCardProps {
  connection: ConnectionWithProfile
  onUnfollow: (userId: string) => void
  onFollow: (userId: string) => void
  isLoading?: boolean
  followingUserIds?: string[] // Lista de IDs que ya sigues
}

export const ConnectionCard = ({ 
  connection, 
  onUnfollow, 
  onFollow,
  isLoading = false,
  followingUserIds = []
}: ConnectionCardProps) => {
  const [actionLoading, setActionLoading] = useState(false);
  
  // Determinar si es una conexión que seguimos o que nos sigue
  const isFollowing = connection.type === 'following';
  const isFollower = connection.type === 'followers';
  
  // Si es un follower, verificar si ya lo seguimos
  const alreadyFollowing = isFollower && followingUserIds.includes(connection.userId);

  const handleAction = async () => {
    setActionLoading(true);
    try {
      if (isFollowing || alreadyFollowing) {
        await onUnfollow(connection.userId);
      } else {
        await onFollow(connection.userId);
      }
    } finally {
      setTimeout(() => setActionLoading(false), 1000);
    }
  };

  const getButtonText = () => {
    if (actionLoading) {
      return (isFollowing || alreadyFollowing) ? 'Unfollowing...' : 'Following...';
    }
    return (isFollowing || alreadyFollowing) ? 'Unfollow' : 'Follow';
  };

  const getButtonIcon = () => {
    if (actionLoading) {
      return <Loader2 className="w-4 h-4 animate-spin mr-2" />;
    }
    return null;
  };

  return (
    <Card className="mb-4 hover:shadow-md transition-shadow">
      <CardContent className="p-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Avatar className="h-10 w-10">
            <AvatarImage src={connection.avatarUrl} alt={connection.name} />
            <AvatarFallback>{connection.name.substring(0, 2).toUpperCase()}</AvatarFallback>
          </Avatar>
          <div>
            <h3 className="text-lg font-medium">{connection.name}</h3>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Button 
            style={{ 
              backgroundColor: (isFollowing || alreadyFollowing) ? '#8B5CF6' : 'transparent',
              borderColor: '#8B5CF6',
              color: (isFollowing || alreadyFollowing) ? 'white' : '#8B5CF6'
            }}
            variant={(isFollowing || alreadyFollowing) ? "default" : "outline"}
            onClick={(e) => { e.stopPropagation(); handleAction(); }}
            disabled={actionLoading || isLoading}
            size="sm"
          >
            {getButtonIcon()}
            {getButtonText()}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}